module.exports = __webpack_public_path__ + "static/media/face-with-spiral-eyes-svgrepo-com.41f35a77.svg";